import React from "react";

import Cards from './Cards';
import "./HomeServices.css";

const HomeServices = ({ home }) =>
  <section className="HomeServices container px-0 ">
    <div className="d-flex justify-content-center">
      <h3 data-aos="fade-up" data-aos-easing data-aos-duration="1000" data-aos-once="true">Our Services:</h3>    
    </div>
    <Cards home={home[0]} />
  </section>


export default HomeServices;
